import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Documento from "model/documentos/Documento";
import DocumentoAlterarAlertaVencimento from "model/documentos/DocumentoAlterarAlertaVencimento";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { useLoadingContext } from "provider/LoadingProvider";
import { useState } from "react";
import DocumentoService from "service/documentos/DocumentoService";

type Props = {
    visible: boolean;
    onHide: () => void;
    documento: Documento;
    onConfirm: () => void;
}

const documentoService = new DocumentoService();

export default function ModalDocumentoAlterarAlertaVencimento(props: Props) {
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();
    const [alertaVencimento, setAlertaVencimento] = useState<boolean>(props.documento.alertaVencimento || false);
    const [diasAlertaVencimento, setDiasAlertaVencimento] = useState<number>(props.documento.diasAlertaVencimento || 0);

    function handleConfirm() {
        if (alertaVencimento && diasAlertaVencimento <= 0) {
            msgAlerta("Erro", "Os dias para alerta de vencimento devem ser maiores que zero.");
            return;
        }

        const dados: DocumentoAlterarAlertaVencimento = {
            id: props.documento.id,
            alertaVencimento,
            diasAlertaVencimento
        };

        startLoading();
        documentoService.alterarAlertaVencimento(dados).then(() => {
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            msgErro("Erro", error?.data?.message || "Erro ao alterar alerta de vencimento");
            console.error("Erro ao alterar alerta de vencimento do documento:", error);
        })
    }

    return (
        <Dialog
            header="Alterar alerta de vencimento"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Alterar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                <Label>Documento</Label>
                <span>{props.documento.codigoInterno} - {props.documento.nome}</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
                <Checkbox checked={alertaVencimento} onChange={(e) => setAlertaVencimento(e.checked as boolean)} />
                <label>Alerta de vencimento</label>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label style={{ fontWeight: 700, color: alertaVencimento ? "#000" : "#777" }} obrigatorio={alertaVencimento}>Dias para alerta de vencimento</Label>
                <div className="col-sm-12">
                    <InputNumber
                        disabled={!alertaVencimento}
                        value={diasAlertaVencimento}
                        onChange={(e) => setDiasAlertaVencimento(e.value as number)}
                    />
                </div>
            </div>
        </Dialog>
    );
}
